import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAssignSettingEnablePdpAttributesEnrichment, useSettingEnablePdpAttributesEnrichment } from "@faire/retailer-visitor-shared/settings/useSettingEnablePdpAttributesEnrichment";
import { getProductDetailsEntriesAttributes, getProductDetailsEntriesTexts } from "@faire/retailer-visitor-shared/views/product/ProductDescriptionAccordions/__internal__/utils";
import { AccordionContainer } from "@faire/retailer-visitor-shared/views/product/ProductDescriptionAccordions/AccordionContainer";
import { ListAccordionContainer } from "@faire/retailer-visitor-shared/views/product/ProductDescriptionAccordions/ListAccordionContainer";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { trackProductInfoProductDescriptionAccordionExpandDetailsSectionClick } from "@faire/web-api--source/events/productInfo/click/productDescriptionAccordionExpandDetailsSection";
import React, { useMemo } from "react";
var INITIAL_NUMBER_OF_LINES_SHOWN = 5;
var MAX_NUMBER_OF_LINES_SHOWN_PER_DETAIL = 2;
export var ProductDetailsAccordion = function(param) {
    var productOption = param.productOption, detailsInformationSection = param.detailsInformationSection, maxPreviewLines = param.maxPreviewLines;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var pdpAttributesEnrichmentEnabled = useSettingEnablePdpAttributesEnrichment();
    var assignPdpAttributesEnrichment = useAssignSettingEnablePdpAttributesEnrichment();
    var title = strictLocalize({
        id: "JNcc2s",
        defaultMessage: [
            {
                type: 0,
                value: "Product details"
            }
        ]
    });
    var productOptionLevelEntries = useMemo(function() {
        var _detailsInformationSection_option_level_entries_by_option_token_productOptionToken, _detailsInformationSection_option_level_entries_by_option_token;
        var productOptionToken = productOption === null || productOption === void 0 ? void 0 : productOption.token;
        if (!productOptionToken) {
            return [];
        }
        return detailsInformationSection === null || detailsInformationSection === void 0 ? void 0 : (_detailsInformationSection_option_level_entries_by_option_token = detailsInformationSection.option_level_entries_by_option_token) === null || _detailsInformationSection_option_level_entries_by_option_token === void 0 ? void 0 : (_detailsInformationSection_option_level_entries_by_option_token_productOptionToken = _detailsInformationSection_option_level_entries_by_option_token[productOptionToken]) === null || _detailsInformationSection_option_level_entries_by_option_token_productOptionToken === void 0 ? void 0 : _detailsInformationSection_option_level_entries_by_option_token_productOptionToken.entries;
    }, [
        detailsInformationSection === null || detailsInformationSection === void 0 ? void 0 : detailsInformationSection.option_level_entries_by_option_token,
        productOption === null || productOption === void 0 ? void 0 : productOption.token
    ]);
    var contents = useMemo(function() {
        if (!detailsInformationSection) {
            return [];
        }
        return _to_consumable_array(getProductDetailsEntriesTexts(detailsInformationSection.entries)).concat(// We display option level entries at the end
        _to_consumable_array(getProductDetailsEntriesTexts(productOptionLevelEntries)));
    }, [
        detailsInformationSection,
        productOptionLevelEntries
    ]);
    var productDetailsList = useMemo(function() {
        if (!detailsInformationSection) {
            return [];
        }
        return _to_consumable_array(getProductDetailsEntriesAttributes(detailsInformationSection.entries)).concat(_to_consumable_array(getProductDetailsEntriesAttributes(productOptionLevelEntries)));
    }, [
        detailsInformationSection,
        productOptionLevelEntries
    ]);
    React.useEffect(function() {
        if (productDetailsList.length > 0) {
            assignPdpAttributesEnrichment();
        }
    }, [
        assignPdpAttributesEnrichment,
        productDetailsList.length
    ]);
    if (pdpAttributesEnrichmentEnabled) {
        if (productDetailsList.length === 0) {
            return null;
        }
        return /*#__PURE__*/ _jsx(ListAccordionContainer, {
            title: title,
            productDetails: productDetailsList,
            maxNumberOfDetailsShownWhenCollapsed: maxPreviewLines !== null && maxPreviewLines !== void 0 ? maxPreviewLines : INITIAL_NUMBER_OF_LINES_SHOWN,
            maxNumberOfLinesShownPerDetail: MAX_NUMBER_OF_LINES_SHOWN_PER_DETAIL,
            onExpandAccordionItem: trackProductInfoProductDescriptionAccordionExpandDetailsSectionClick
        });
    } else {
        if (contents.length === 0) {
            return null;
        }
        return /*#__PURE__*/ _jsx(AccordionContainer, {
            title: title,
            text: contents.join("\n"),
            isListOfItems: true,
            maxNumberOfLinesShownWhenCollapsed: maxPreviewLines !== null && maxPreviewLines !== void 0 ? maxPreviewLines : INITIAL_NUMBER_OF_LINES_SHOWN,
            onExpandAccordionItem: trackProductInfoProductDescriptionAccordionExpandDetailsSectionClick
        });
    }
};
